<!-- @format -->

<template>
	<div :class="isHeight ? 'myService serviceHeightMax' : 'myService'">
		<div ref="myServiceAllRef" class="myServiceAll work-img-border">
			<div class="myServiceTop">
				<el-row style="width: 100%">
					<div style="display: flex; align-items: center; width: 100%">
						<el-col :span="10">
							<span class="myServiceText">
								我的服务
								<span v-if="!isWorkbenchedit" class="arrowIconName"></span>
							</span>
						</el-col>
						<el-col :span="isWorkbenchedit ? 12 : 14">
							<el-input v-model="searchValue" placeholder="请输入流程名称/分类">
								<template #suffix>
									<el-icon class="el-input__icon" @click="onSearch"><search /></el-icon>
								</template>
							</el-input>
						</el-col>
						<el-col class="setting" :span="2">
							<el-icon v-if="isWorkbenchedit" style="margin-right: 10px" @click="showDialog">
								<icon-ant-design:setting-outlined />
							</el-icon>
							<el-icon v-if="isWorkbenchedit" @click="delEdit">
								<icon-ant-design:delete-outlined />
							</el-icon>
						</el-col>
					</div>
				</el-row>
			</div>

			<el-carousel
				v-if="isShowCarousel"
				ref="carouselRef"
				trigger="click"
				:height="isHeight ? '' : 'auto'"
				:autoplay="false"
				:arrow="carouselTotal > 1 ? 'hover' : 'never'"
				@wheel.prevent="handleWheel"
			>
				<el-carousel-item v-for="itemYe in carouselTotal" :key="itemYe">
					<div class="myServiceContent">
						<span
							v-for="item in divisionArray[itemYe - 1]"
							:key="item.code"
							class="contentBox"
							:style="getContentBoxStyle()"
							@click="goToWorkorder(item.code)"
						>
							<img :src="item.url" alt="" style="height: 50px; margin-bottom: 10px" />
							<span v-if="item.name" class="contentText">{{ item.name }}</span>
							<el-tooltip :content="item.name" placement="top"></el-tooltip>
						</span>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>

	<!-- 对话框 -->
	<el-dialog
		v-model="dialogVisible"
		:close-on-click-modal="false"
		append-to-body
		title="我的服务"
		width="50%"
		:before-close="dialogCancel"
		custom-class="myServiceDialog"
	>
		<el-transfer
			v-model="transferValue"
			:titles="['未展示服务', '已展示服务']"
			:data="transferData"
			target-order="push"
			@change="transferChange"
		/>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="dialogCancel">取消</el-button>
				<el-button type="primary" @click="dialogDetermine">确定</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup name="myService">
	import { ref, watch } from 'vue';
	import { getEnvUrlByUrl } from '@power/runtime-vue3';
	import { openWindow } from '@power/utils';
	import { Search } from '@element-plus/icons-vue';
	import { workflowTypes } from '@/api/powercess/workbench';
	import ServiceRequest from '@/assets/images/ServiceRequest.png';
	import ChangeProcess from '@/assets/images/ChangeProcess.png';
	import EventFlow from '@/assets/images/EventFlow.png';
	import ReleaseProcess from '@/assets/images/ReleaseProcess.png';
	import ProblemProcess from '@/assets/images/ProblemProcess.png';
	const emit = defineEmits(['deletePanelItemEvent', 'selectItemEvent']);
	const props = defineProps({
		isHeight: {
			type: [Boolean],
		},
		isWorkbenchedit: {
			type: [Boolean],
		},
		id: {
			type: [Number, String],
		},
		editArray: {
			type: [Array],
		},
		serviceHeight: {
			type: [Number, String],
		},
	});

	// 配置参数
	const ITEM_HEIGHT = 80; // 每个item固定高度
	const flexGap = 10; // item之间的间距
	const itemMinWidth = ref(120); // item最小宽度
	const maxItemsPerRow = 6; // 每行最大item数

	const searchValue = ref('');

	// DOM引用
	const myServiceAllRef = ref(null); // 外层固定容器
	const carouselRef = ref(null);
	const resizeObserver = ref(null); // ResizeObserver实例

	// 数据相关
	const workTypeList = ref([]);
	const serviceList = ref([]);
	const servicebg = ref([]);
	const carouselTotal = ref(1);
	const dialogVisible = ref(false);
	const transferData = ref(generateData());
	const transferValue = ref(props.editArray?.length ? props.editArray : []);
	const divisionArray = ref([]);
	const isShowCarousel = ref(false);
	const dynamicItemsPerRow = ref(4); // 动态每行item数量

	const onSearch = () => {
		const keyword = searchValue.value.trim().toLowerCase();

		if (!keyword) {
			serviceList.value = transferValue.value
				.map((val) => workTypeList.value.find((item) => item.code === val))
				.filter(Boolean);
			groupData(serviceList.value);
			return;
		}

		const filteredList = workTypeList.value.filter((item) => {
			return item.name?.toLowerCase().includes(keyword) || item.classificationName?.toLowerCase().includes(keyword);
		});

		serviceList.value = filteredList;
		groupData(serviceList.value);
	};
	/**
	 * 计算动态每行item数量
	 */
	const getDynamicItemsPerRow = () => {
		if (!myServiceAllRef.value) return 4;

		// 计算实际可用宽度（减去内边距）
		const containerWidth = myServiceAllRef.value.clientWidth - 40;
		if (containerWidth <= 0) return 4;

		const itemsPerRow = Math.floor(containerWidth / itemMinWidth.value);
		return Math.max(1, Math.min(itemsPerRow, maxItemsPerRow));
	};

	/**
	 * 宽度变化时触发：更新每行数量 + 重新分组数据
	 */
	const handleResize = () => {
		const newItemsPerRow = getDynamicItemsPerRow();
		if (dynamicItemsPerRow.value !== newItemsPerRow) {
			dynamicItemsPerRow.value = newItemsPerRow;
			groupData(serviceList.value);
		}
	};

	/**
	 * 计算每页item数量
	 */
	const getItemsPerPage = () => {
		const height = Number(props.serviceHeight) || 80;
		const result = height / ITEM_HEIGHT;
		const decimalPart = Math.floor((result % 1) * 10);
		const rows = decimalPart <= 5 ? Math.floor(result) : Math.ceil(result);
		return Math.max(rows, 1) * dynamicItemsPerRow.value;
	};

	/**
	 * 计算item的动态宽度
	 */
	const getContentBoxStyle = () => {
		const itemsPerRow = dynamicItemsPerRow.value;
		const width = `calc(
    100% / ${itemsPerRow} -
    (${flexGap}px * (${itemsPerRow} - 1)) / ${itemsPerRow}
  )`;
		return { width };
	};

	function delEdit() {
		emit('deletePanelItemEvent', props.id);
	}

	function onceList() {
		workflowTypes({ permissionType: 'CREATE' }).then((res) => {
			const data = res.data.map((item) => ({ ...item, disabled: false }));
			const arr2 = [
				{ url: ServiceRequest },
				{ url: ChangeProcess },
				{ url: EventFlow },
				{ url: ReleaseProcess },
				{ url: ProblemProcess },
			];
			servicebg.value = data.map((item, index) => ({ ...item, ...arr2[index % 5] }));
			workTypeList.value = servicebg.value;
			transferData.value = generateData();

			// 筛选已选服务
			const service = transferValue.value
				.map((val) => workTypeList.value.find((item) => item.code === val))
				.filter(Boolean);
			serviceList.value = service;
			groupData(serviceList.value);

			// 数据加载后触发宽度计算
			nextTick(() => {
				handleResize();
			});
		});
	}

	function groupData(array) {
		const itemsPerPage = getItemsPerPage();
		let index = 0;
		const newArray = [];
		while (index < array.length) {
			newArray.push(array.slice(index, (index += itemsPerPage)));
		}
		divisionArray.value = newArray;
		carouselTotal.value = newArray.length || 1;
		isShowCarousel.value = true;
	}
	// 渲染要展示的数据
	function generateData() {
		return workTypeList.value.map((item) => ({
			key: item.code,
			label: item.name,
			disabled: item.disabled,
		}));
	}

	function showDialog() {
		dialogVisible.value = true;
		const disabledCodes = workTypeList.value.filter((item) => item.disabled).map((item) => item.code);
		transferValue.value = transferValue.value.filter((code) => !disabledCodes.includes(code));
	}

	function dialogDetermine() {
		emit('selectItemEvent', {
			selectList: transferValue.value,
			module: props.id,
		});
		serviceList.value = transferValue.value
			.map((val) => workTypeList.value.find((item) => item.code === val))
			.filter(Boolean);
		groupData(serviceList.value);
		dialogVisible.value = false;
	}

	function dialogCancel() {
		transferValue.value = serviceList.value.map((item) => item.code);
		dialogVisible.value = false;
	}

	function transferChange(rightList) {
		transferValue.value = rightList;
	}

	function goToWorkorder(modelCode) {
		if (!props.isWorkbenchedit) {
			let url = `powerprocess/dealOrder/${modelCode}`;
			url = getEnvUrlByUrl(url);
			openWindow(url);
		}
	}

	const handleWheel = (e) => {
		if (!carouselRef.value) return;
		e.stopPropagation();
		e.deltaY > 0 ? carouselRef.value.next() : carouselRef.value.prev();
	};

	onMounted(() => {
		// 初始化ResizeObserver
		resizeObserver.value = new ResizeObserver((entries) => {
			if (entries[0]) handleResize();
		});

		// 确保DOM渲染完成后再监听
		nextTick(() => {
			if (myServiceAllRef.value) {
				resizeObserver.value.observe(myServiceAllRef.value);
			}
		});
	});

	onUnmounted(() => {
		// 关键修复：先检查元素是否存在再执行unobserve
		if (resizeObserver.value) {
			// 先尝试取消对元素的观察
			if (myServiceAllRef.value && typeof myServiceAllRef.value === 'object') {
				try {
					resizeObserver.value.unobserve(myServiceAllRef.value);
				} catch (e) {
					console.warn('取消观察时发生错误:', e);
				}
			}
			// 断开所有观察器连接
			resizeObserver.value.disconnect();
		}
	});

	// 监听高度变化
	watch(
		() => props.serviceHeight,
		() => groupData(serviceList.value),
		{ immediate: true },
	);

	watch(
		() => searchValue.value,
		() => {
			clearTimeout(window.searchTimer);
			window.searchTimer = setTimeout(() => {
				onSearch();
			}, 300);
		},
	);

	onceList();
</script>

<style scoped lang="scss">
	:deep(.el-carousel__button) {
		background-color: #bfbfbf;
	}

	:deep(.el-carousel__indicators--horizontal) {
		display: flex;
		justify-content: center;
		width: 100%;
	}

	:deep(.el-input__suffix) {
		cursor: pointer;
	}

	:deep(.el-input__wrapper) {
		border-radius: 8px !important;
	}

	.myService {
		height: 100%;
		padding: 12px 0 0 12px;

		.myServiceAll {
			height: 100%;
			padding: 20px;
			background: var(--theme-workbench-bg-color);
		}

		.myServiceTop {
			height: 40px;
			opacity: 0.9;
			font-weight: 600;

			.myServiceText {
				font-weight: 600;
				font-size: 18px;
			}

			.arrowIconName {
				vertical-align: middle;
				display: inline-block;
				width: 164px;
				height: 16px;
				background-size: contain;
				margin-left: 10px;
			}

			.setting {
				text-align: right;

				.el-icon {
					cursor: pointer;
				}
			}
		}

		:deep .el-carousel__arrow {
			display: none;
		}

		.myServiceContent {
			height: calc(100% - 40px);
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			gap: 10px;
			padding: 10px;

			.contentBox {
				display: flex;
				flex-direction: column;
				align-items: center;
				height: 100px;
				text-align: center;
				cursor: pointer;
				background-size: 70px;
				color: var(--theme-workbench-title-color);

				.contentText {
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}

				span {
					text-align: center;
					display: block;
					line-height: 19px;
					font-size: 14px;
					font-family: 'PingFang SC-Heavy';
					color: #000 !important;
				}
			}

			.contentBox:hover {
				background-size: 70px;
				color: var(--theme-workbench-icon-border-hover-color);
			}
		}
	}

	.serviceHeightMax {
		padding: 0;
		background: var(--theme-background-color);

		:deep .el-carousel {
			height: calc(100% - 40px);

			.el-carousel__container {
				height: 100%;
			}
		}

		:deep .myServiceContent {
			margin-top: 1.1rem;

			.contentBox {
				span {
					font-weight: 600;
				}
			}
		}
	}
</style>
<style lang="scss">
	.myServiceDialog {
		.el-transfer {
			text-align: center;
		}
	}
</style>
